import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('LongTask', LongTaskData);

    LongTaskData.$inject = ['UtilSvc'];
    /* @ngInject */
    function LongTaskData(UtilSvc) {
        LongTask.prototype = {
            build: build
        };

        function LongTask(longTaskData) {
            if (longTaskData) {
                this.build(longTaskData);
            }
        }

        return LongTask;

        /////////////////////
        function build(longTaskData) {
            this.id = longTaskData.id || null;
            this.type = longTaskData.type || null;
            this.startDate = UtilSvc.parseDate(longTaskData.startDate);
            this.endDate = UtilSvc.parseDate(longTaskData.endDate);
            this.stepCount = longTaskData.stepCount || null;
            this.stepCurrent = longTaskData.stepCurrent || null;
            this.stepName = longTaskData.stepName || null;
            this.result = UtilSvc.parseJson(longTaskData.result);
        }
    }
})();
